import { Button, Space, Table, Typography } from "antd";
import { useGetParticipants } from "@hooks";
import { participantTable } from "@configurations";
import { Dispatch, SetStateAction, useState } from "react";
import { useEditExamPeriod } from "@hooks";
import { ExamPeriod, Participant } from "@types";
import { useTranslation } from "react-i18next";

interface Props {
  examPeriod: ExamPeriod;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const ExamParticipantTable = ({ examPeriod, setIsModalOpen }: Props) => {
  const { data, isLoading } = useGetParticipants();
  const [selectedRowKeys, setSelectedRowKeys] = useState<Participant[]>([]);
  const editExamPeriod = useEditExamPeriod();
  const { t } = useTranslation();

  const onFinish = () => {
    editExamPeriod.mutate(
      {
        ...examPeriod,
        // participants: [...examPeriod.participants, ...selectedRowKeys],
        userExaminees: [...examPeriod.userExaminees, ...selectedRowKeys]
      },
      {
        onSuccess() {
          setIsModalOpen(false);
        },  
      }
    );
  };

  const onSelectChange = (_: React.Key[], selectedRows: Participant[]) => {
    setSelectedRowKeys(selectedRows);
  };

  return (
    <div>
      <Table
        loading={isLoading}
        dataSource={data?.items.filter(
          (item: any) => !examPeriod.userExaminees.some((p) => p.id === item.id)
        )}
        size="small"
        rowKey={(record) => record.id}
        pagination={{
          showTotal: (total) =>
            `${t("pages.examPeriods.applicantsTab.applicantsTotal")}: ${total}`,
        }}
        rowSelection={{
          type: "checkbox",
          onChange: onSelectChange,
        }}
        columns={participantTable}
      />
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <Space>
          <Typography.Text>
            {t("pages.examPeriods.applicantsTab.selected")}:{" "}
            <Typography.Text strong>{selectedRowKeys.length}</Typography.Text>
          </Typography.Text>
          <Button
            type="primary"
            disabled={selectedRowKeys.length == 0}
            loading={editExamPeriod.isPending}
            onClick={onFinish}
          >
            {t("pages.examPeriods.save")}
          </Button>
        </Space>
      </div>
    </div>
  );
};
